import React from "react";
import {
  Cow,
  MapPin,
  MagnifyingGlass,
  ArrowsDownUp,
  SortAscending,
  SortDescending
} from "@phosphor-icons/react";

export function MartFilters({
  categories,
  provinces,
  selectedCategory,
  setSelectedCategory,
  selectedProvince,
  setSelectedProvince,
  selectedCounty,
  setSelectedCounty,
  sortBy,
  setSortBy,
  searchQuery,
  setSearchQuery,
  counties
}) {
  return (
    <div className="flex flex-wrap items-center gap-4 mb-6 p-4 bg-[#064E3B] border border-[#065F46]">
      <div className="flex items-center gap-2">
        <Cow size={18} className="text-[#6EE7B7]" />
        <select
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          data-testid="category-filter"
          className="px-3 py-2 bg-[#065F46] border border-[#0F766E] text-white font-sans text-sm focus:outline-none focus:border-[#0F766E]"
        >
          {categories.map((cat) => (
            <option key={cat.id} value={cat.id}>{cat.name}</option>
          ))}
        </select>
      </div>

      <div className="flex items-center gap-2">
        <MapPin size={18} className="text-[#6EE7B7]" />
        <select
          value={selectedProvince}
          onChange={(e) => {
            setSelectedProvince(e.target.value);
            setSelectedCounty("");
          }}
          data-testid="province-filter"
          className="px-3 py-2 bg-[#065F46] border border-[#0F766E] text-white font-sans text-sm focus:outline-none focus:border-[#0F766E]"
        >
          <option value="">All Provinces</option>
          {provinces.map((prov) => (
            <option key={prov} value={prov}>{prov}</option>
          ))}
        </select>
      </div>

      {counties && counties.length > 0 && (
        <select
          value={selectedCounty}
          onChange={(e) => setSelectedCounty(e.target.value)}
          data-testid="county-filter"
          className="px-3 py-2 bg-[#065F46] border border-[#0F766E] text-white font-sans text-sm focus:outline-none focus:border-[#0F766E]"
        >
          <option value="">All Counties</option>
          {counties.map((county) => (
            <option key={county} value={county}>{county}</option>
          ))}
        </select>
      )}

      <div className="flex items-center gap-2">
        <ArrowsDownUp size={18} className="text-[#6EE7B7]" />
        <select
          value={sortBy}
          onChange={(e) => setSortBy(e.target.value)}
          data-testid="sort-filter"
          className="px-3 py-2 bg-[#065F46] border border-[#0F766E] text-white font-sans text-sm focus:outline-none focus:border-[#0F766E]"
        >
          <option value="price_desc">Highest Price</option>
          <option value="price_asc">Lowest Price</option>
          <option value="change_desc">Biggest Gain</option>
          <option value="change_asc">Biggest Drop</option>
          <option value="name_asc">Name A-Z</option>
        </select>
      </div>

      <div className="relative flex-1 min-w-[200px]">
        <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#6EE7B7]" />
        <input
          type="text"
          placeholder="Search marts..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          data-testid="search-input"
          className="w-full pl-9 pr-4 py-2 bg-[#065F46] border border-[#0F766E] text-white font-sans text-sm placeholder:text-[#6EE7B7]/60 focus:outline-none focus:border-[#14B8A6]"
        />
      </div>
    </div>
  );
}

export function SortToggle({ sortOrder, onToggle }) {
  return (
    <button
      onClick={onToggle}
      className="p-2 bg-[#065F46] text-[#6EE7B7] hover:bg-[#0F766E] transition-colors"
      title={sortOrder === "desc" ? "Highest First" : "Lowest First"}
    >
      {sortOrder === "desc" ? <SortDescending size={18} /> : <SortAscending size={18} />}
    </button>
  );
}

export default MartFilters;
